import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Tooltip from "module-common/Tooltip";
import Icon from "module-common/Icon";

export default class FieldRow extends Component {
  static propTypes = { label: PropTypes.string };

  render() {
    const { label, className, onChange, ...rest } = this.props;

    const labelName =
      label === "Nickname" ? (
        <Label>
          {label}
          <Tooltip text="Max 10 character">
            <Icon name="information" width={10} height={10} />
          </Tooltip>
        </Label>
      ) : (
        <Label>{label}</Label>
      );

    return (
      <Wrapper className={className}>
        {labelName}
        <Colon>:</Colon>
        <TextInput id={label} type="text" onChange={this.onChange} {...rest} />
      </Wrapper>
    );
  }

  onChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  };
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin-bottom: 10px;
`;
const Label = styled.label`
  width: 70px;
  flex: none;
`;
const Colon = styled.div`
  margin-left: auto;
  margin-right: 14px;
`;
const TextInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: none;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
`;



// WEBPACK FOOTER //
// ./src/module-agent-management/FieldRow.js